import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { notDesktop } from '@libraries/ui-state';
import { select, Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';
import { CloseActive, getAddressChoices, isRightOutletLoading, SelectAddress } from '../../state';

@Component({
  templateUrl: './addresses.component.html',
  styleUrls: ['./addresses.component.scss'],
  standalone: false,
})
export class AddressesComponent implements OnInit {
  public addressesForm: UntypedFormGroup;
  public addressChoices$ = this.store.pipe(select(getAddressChoices), take(1));
  public isLoading$ = this.store.pipe(select(isRightOutletLoading));
  private notDesktop$ = this.store.select(notDesktop);

  constructor(private fb: UntypedFormBuilder, private store: Store) {
    this.addressesForm = this.fb.group({
      address: [undefined, Validators.required],
    });
  }

  ngOnInit() {
    this.notDesktop$
      .pipe(
        take(1),
        filter((nonDesktop) => nonDesktop)
      )
      .subscribe(() => window.scrollTo(0, 0));
  }

  submit() {
    this.addressesForm.markAllAsTouched();
    if (this.addressesForm.invalid) return;
    this.store.dispatch(SelectAddress({ payload: this.addressesForm.value.address }));
  }

  close() {
    this.store.dispatch(CloseActive());
  }
}
